import { Component, OnInit } from '@angular/core';
import { LoginService } from './login.service';
import { ModuleService } from './module.service';
import { SharedDataService } from '../shared-data.service';
import {Router} from '@angular/router';
import {Message} from 'primeng/primeng';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loginFailed = false;
  loginData = { username: "", password: ""};

  msgs : Message[] = [];

  constructor(private loginService : LoginService, public shared : SharedDataService, private router : Router,
        private moduleService : ModuleService) { }

  ngOnInit() {
  }

  loginSuccessful() {
    this.moduleService.loadEnabledModules();
    this.router.navigate(['/article']);
  }

  loginError () {
    this.msgs = [];
    console.log(this.shared.testVariable);
    this.loginFailed = true;
    this.shared.getLoginData().isLoggedIn = false;
    this.msgs.push({severity:'warn', summary:'Login failed', detail:'Bei der Anmeldung ist ein Fehler aufgetreten.'});
  }

  tryLogin() {
    console.log('tryLogin was called.');
    this.loginFailed = false;

    this.loginService.login(
      this.loginData.username,
      this.loginData.password).subscribe(
        token => {
          if(token.valid)
          {
            let loginData = this.shared.getLoginData();
            loginData.credentials.token = token.token;
            loginData.credentials.username = this.loginData.username;
            loginData.credentials.userId = token.userid;
            loginData.isLoggedIn = true;

            // set login data (this way it is also stored in session)
            this.shared.setLoginData(loginData);

            this.loginSuccessful();
          }else{
            this.loginError();
          }
        },
        err => {
          this.loginError();
        }
    );
  }

  public onSubmit() {
    this.tryLogin();
  }
}



// WEBPACK FOOTER //
// /home/pneuser/workspace/pepelogistic/pepeLogisticControl/src/app/login/login.component.ts